import React, { useState } from "react";
import api from "@/lib/api";
import { Field } from "@/components/ui-helpers";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

function PwdInput({ value, onChange, testId, placeholder }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input type={show ? "text" : "password"} value={value} onChange={onChange} className="pr-10"
        placeholder={placeholder} data-testid={testId} />
      <button type="button" onClick={() => setShow((v) => !v)} tabIndex={-1}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground p-1"
        aria-label={show ? "Sembunyikan" : "Tampilkan"} data-testid={`${testId}-toggle`}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const save = async () => {
    if (!current || !next) return toast.error("Lengkapi semua kolom");
    if (next.length < 6) return toast.error("Password baru minimal 6 karakter");
    if (next !== confirm) return toast.error("Konfirmasi password tidak cocok");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password berhasil diubah");
      reset();
      onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal mengubah password"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Ubah Password</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Field label="Password Saat Ini" required><PwdInput value={current} onChange={(e) => setCurrent(e.target.value)} testId="cp-current" /></Field>
          <Field label="Password Baru" required hint="Minimal 6 karakter"><PwdInput value={next} onChange={(e) => setNext(e.target.value)} testId="cp-new" /></Field>
          <Field label="Konfirmasi Password Baru" required><PwdInput value={confirm} onChange={(e) => setConfirm(e.target.value)} testId="cp-confirm" /></Field>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Batal</Button>
          <Button onClick={save} disabled={busy} data-testid="cp-save">{busy ? "Menyimpan..." : "Simpan"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
